import { render, staticRenderFns } from "./votes.vue?vue&type=template&id=653824ea&"
import script from "./votes.vue?vue&type=script&lang=js&"
export * from "./votes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports